export default {
  toolsPanel_isOpened: false,
  toolsPanel_openedItemsDescription: {},
  toolsPanel_visibleItem: null,
  toolsPanel_itemsDescription: {
    addWidget: {
      id: 'addWidget',
      name: 'Add Widget',
    },
    editWidget: {
      id: 'editSingleCard',
      name: 'Add Single Card',
      key: null,
    },
    editCustomCode: {
      id: 'editCustomCode',
      name: 'Edit Custom Code',
    },
    editComputed: {
      id: 'editComputed',
      name: 'Edit Computed',
    },
    editSettings: {
      id: 'editSettings',
      name: 'Edit Settings',
    },
    editWorkflow: {
      id: 'editWorkflow',
      name: 'Edit Workflow',
    },
  },
}
